// removed by extract-text-webpack-plugin
module.exports = {"colors":"\"styles/colors.css\"","primary":"#492172","zLightBlue":"rgb(75, 137, 220)","tertiary":"#BFD730","progress":"tbtB","determinate":"rvCS","indeterminate":"_33iU","indeterminate-short":"X9bC"};


//////////////////
// WEBPACK FOOTER
// ./~/@pickle/pickle-shared/src/components/Loading/LoadingLinear/LoadingLinear.scss
// module id = ZwiE
// module chunks = 0